module.exports = __webpack_public_path__ + "img/mergdata_hifi_5.47a287f0.png";